var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowUpBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.709 32.8917L11.5007 30.6813L23.5361 18.6417C23.7289 18.4476 23.9582 18.2936 24.2108 18.1885C24.4635 18.0834 24.7343 18.0293 25.0079 18.0293C25.2815 18.0293 25.5524 18.0834 25.805 18.1885C26.0576 18.2936 26.287 18.4476 26.4798 18.6417L38.5215 30.6813L36.3132 32.8896L25.0111 21.5896L13.709 32.8917Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 50,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpBlack);
export default __webpack_public_path__ + "static/media/ic_arrow_up_black.7aa817e15436c10ebef31e855f26df11.svg";
export { ForwardRef as ReactComponent };